import { render } from "./CalendarDay.vue?vue&type=template&id=71f5a2e6"
import script from "./CalendarDay.vue?vue&type=script&lang=js"
export * from "./CalendarDay.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__